<template>
  <div style="width: 100%; height: 100%">
    <ManageUser></ManageUser>
    <Map></Map>
    <SearchGeneralGeodirClaro></SearchGeneralGeodirClaro>
    <SideNavSedapar></SideNavSedapar>
    <DataQuality></DataQuality>
    <StreetView></StreetView>
    <HereClaro></HereClaro>
    <BannerUbicasa></BannerUbicasa>
    <SedaparLogo posicion="bottom-left"></SedaparLogo>
  </div>
</template>

<script>
import Map from "./Map";
import ManageUser from "@/components/ManageUser";
import SearchGeneralGeodirClaro from "@/components/searchGeneral/SearchGeneralGeodirClaro";
import DataQuality from "@/components/DataQuality/DataQuality";
import StreetView from "@/components/StreetView";
import HereClaro from "@/components/Opciones/HereClaro";
import BannerUbicasa from "@/components/Opciones/BannerUbicasa.vue";

import SedaparLogo from "@/components/clientes/sedapar/SedaparLogo.vue";
import sedaparConfig from "@/components/clientes/sedapar/sedaparConfig";
import SideNavSedapar from "@/components/sidenavs/SideNavSedapar";

export default {
  name: "GeodirMapSedapar",
  components: {
    Map,
    SideNavSedapar,
    ManageUser,
    SearchGeneralGeodirClaro,
    DataQuality,
    StreetView,
    HereClaro,
    BannerUbicasa,
    SedaparLogo,
  },
  created() {
    document.title = sedaparConfig.titulo;
  },
  mounted() {
    const esMovil = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(
      navigator.userAgent
    );
    if (!esMovil || !navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition(
      (e) => {
        localStorage.setItem("longitude", e.coords.longitude);
        localStorage.setItem("latitude", e.coords.latitude);
      },
      () => {
        // Solo limpia la ubicación, no la sesión del usuario
        localStorage.removeItem("longitude");
        localStorage.removeItem("latitude");
      },
      { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
    );
  },
};
</script>

<style>
/* Minificha general */
.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
  border-radius: 4px !important;
}

.atributo {
  color: #979da1 !important;
  font-size: 13px;
  margin-bottom: 2px;
}

.valor {
  line-height: 1.4 !important;
  font-size: 13px;
}

/* Scroll general */
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb {
  background: #9c9c9c;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb:hover {
  background: #888888;
}
</style>